<div class="contact-container">
  <h1>{{ "Frequently Asked Questions" | translate }}</h1>
  <p>
    {{
      "If you have any question , we hope you will find helpful answer and you can search about your questions"
        | translate
    }}
  </p>
  <div class="mx-0 mx-md-5">
    <p-accordion
      [multiple]="true"
      expandIcon="bi bi-plus-circle fs-4"
      collapseIcon="bi bi-dash-circle fs-4
    "
    >
      <p-accordionTab class="m-1" *ngFor="let item of data" [header]="item.ask">
        <p [innerHTML]="item.answer"></p>
      </p-accordionTab>
    </p-accordion>
  </div>
</div>
